import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../actions/baseActions";
import { setObj } from "../../../../../actions/noteActions";
import Breadcrumb from "../../../../../components/Breadcrumb";
import Form from "../../../../../components/Forms/Form";
import { required } from "../../../../../components/Forms/validators";
import Loading from "../../../../../components/Loading";
import ProtectedRoute from "../../../../../components/ProtectedRoute";
import URL from "../../../../../config/api";
import axios from "../../../../../config/axios";

class HelpdeskCategoryCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false
    };

    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const idUser = this.props.match.params.id;

    if (idUser) {
      this.setState({ loading: true, id: idUser }, () => {
        axios
          .get(`${URL.api}helpdesk/category/singleView/${idUser}`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(
            resp => {
              this.setState({
                category: resp.data.data,
                edit: true,
                loading: false
              });
            },
            error => {
              this.error(error.response.statusText);
            }
          );
      });
    }
  }

  enviar(value) {
    const obj = {
      name: value.name
    };

    axios
      .post(`${URL.api}helpdesk/category/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/helpdesk/category/list");
      });
  }

  atualizar(value) {
    const obj = {
      id: this.state.id,
      name: value.name
    };

    axios
      .post(`${URL.api}helpdesk/category/update/${this.state.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/helpdesk/category/list");
      });
  }

  render() {
    const fields = [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required]
      }
    ];

    let buttons = [
      {
        name: "Enviar",
        submit: false,
        icon: "fa fa-cloud mr-2",
        iconSide: "left",
        custom: this.enviar,
        color: "primary"
      }
    ];

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            { path: "/helpdesk/category/list", to: "/helpdesk/category/list" }
          ]}
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <div>
            <Form
              avatar
              fields={fields}
              back
              history={this.props.history}
              buttons={buttons}
              onSubmit={this.state.edit ? this.atualizar : this.enviar}
              initialValues={this.state.category}
              edit={this.state.edit}
            />
          </div>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HelpdeskCategoryCreate);
